export default {
  name: 'Start Date and Time',
  edit: {
    form: 'date-time-picker',
    label: 'Change the start date',
    handler: value => value,
  },
};
